
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/[parent]/[child]",
      function () {
        return require("private-next-pages/services/[parent]/[child].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/[parent]/[child]"])
      });
    }
  